<template>
  <div class="company-card__hint-inner">
    <div class="company-card__hint-icon">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="9" fill="#27CC24" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7128 5.09889C14.0092 5.27908 14.0892 5.64416 13.8915 5.91432L8.70587 13L4.17362 8.5765C3.93044 8.33916 3.94442 7.96708 4.20484 7.74545C4.46526 7.52381 4.87351 7.53655 5.1167 7.7739L8.53671 11.1118L12.8181 5.26178C13.0158 4.99163 13.4163 4.9187 13.7128 5.09889Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="company-card__hint-text">
      {{ $t('company_card.hint.active') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCardHintActive',
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
.company-card {
  &__hint {
    &-icon {
      background-color: #eaffea;
    }

    &-text {
      display: flex;
      align-items: center;
      background-color: #eaffea;
      border-radius: 15px;
      padding: 15px 27px;
    }
  }
}
</style>
